export default __webpack_public_path__ + "static/f18-50780806f6b1973f81ad2130441ceb4b.svg";